import React from 'react';
import PropTypes from 'prop-types';

import SectionCard from '../../components/SectionCard';
import MessageBodyField from '../../components/MessageBodyField';
import texts from '../../texts.json';

const MessageSection = ({
  body,
  onBodyChange,
  coachName,
  hasImage,
}) => (
  <SectionCard title={texts.sections.message.title}>
    <MessageBodyField
      body={body}
      onBodyChange={onBodyChange}
      minRows={6}
      coachName={coachName}
      hasImage={hasImage}
    />
  </SectionCard>
);

MessageSection.propTypes = {
  body: PropTypes.string.isRequired,
  onBodyChange: PropTypes.func.isRequired,
  coachName: PropTypes.string,
  hasImage: PropTypes.bool,
};

MessageSection.defaultProps = {
  coachName: '',
  hasImage: false,
};

export default MessageSection;
